import { FormInstance, UploadFile, UploadProps, message } from "antd";
import { serverUrl } from "../../../Constants/env";

export default function createUploaderPropsPE (
    token: string,
    mdwFormatId: string,
    form: FormInstance<any>,
    accept = '.txt',
    success?: (file: UploadFile<any>) => void,
    // postProcessing = false
): UploadProps {
    // console.log(postProcessing)
    return {
        multiple: false,
        maxCount: 1,
        action: `${serverUrl}v3/pe/oc/format?mdwFormatId=${mdwFormatId}`,
        headers: {
            Authorization: `Bearer ${token}`
        },
        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                
                const { consolidated, detailed } = info.file.response // ,homologated
                
                // if (isImported || isLoaded) {
                    //     message.warning(`${info.file.name} ya ha sido ${isImported && 'importado'}${isLoaded && 'inyectado'} anteriormente. Revisa en el panel de "Importador de Documentos" en tu ERP.`);
                    //     return
                    // }
                    
                if (info.file.response.status === 'success') {
                    message.success(`${info.file.name} cargado exitosamente.`);
                    // const _orders = form.getFieldValue('orders') ?? [];
                    form.setFieldsValue({
                        orders: [
                            {
                                // path: info.file.response.path,
                                number: detailed[0].CAB_OC,
                                consolidated,
                                detailed,
                                filename: detailed[0].CAB_OC,
                                // filename: info.file.name,
                                // detail: info.file.response.redux,
                                // config: {
                                //     tascam,
                                //     correlativo,
                                //     requireFolio,
                                // }
                            }
                        ]
                    })
                    if(success) {
                        success(info.file)
                    }
                } else { 
                    message.error(info.file.response.message)
                }
            } else if (status === 'error') {
                message.error(`${info.file.name} tuvo problemas, revisa el formato e intenta nuevamente.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
        onRemove(file) {
            const _orders = form.getFieldValue('orders') ?? [];
            form.setFieldsValue({ orders: _orders.filter((item: any) => item.path !== file.response.path) })
        },
        accept
    };
}